import { updateLocale } from '@americanexpress/one-app-ducks';
import { v4 as uuid } from 'uuid';
import { setCorrelationId } from '../ducks';

export default function updateLocaleFromRoute({ dispatch }) {
  return async (nextState, replace, callback) => {
    const { params: { locale } } = nextState;
    const correlationId = uuid();
    try {
      const formattedLocale = locale.replace(
        /-([a-z]{2})/i,
        (match, group) => `-${group.toUpperCase()}`
      );
      await dispatch(updateLocale(formattedLocale));
      await dispatch(setCorrelationId(correlationId));
    } catch (error) {
      replace({
        pathname: '/error',
      });
    }

    return callback();
  };
}
